import { ItemBiblioteca } from '../../../core/types/graphql'
import { parseAsString, useQueryState } from 'nuqs'

export const useSelectViewItem = () => {
  const [selectedViewItem, setSelectedViewItem] = useQueryState(
    'selectedView',
    parseAsString.withDefault('')
  )

  const onCloseViewItem = () => {
    setSelectedViewItem('')
  }

  const onSelectViewItem = (item: ItemBiblioteca) => {
    setSelectedViewItem(item.id)
  }

  return {
    selectedViewItem,
    onCloseViewItem,
    onSelectViewItem
  }
}
